import {
  SURVEY_ROUTE_PERMISSIONS_MANAGE_ANY,
  SURVEY_ROUTE_PERMISSIONS_VIEW_ANY,
} from '@/modules/campanhas/pesquisa-satisfacao/helpers/surveyRoutePermissions.js'

const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsCampanhas = { name: 'Campanhas', pathName: null, action: 'campanhas' }

export default [
  {
    path: '/v3/campanhas',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    children: [
      {
        path: 'email',
        alias: ['email-marketing', 'campanhas-email'],
        component: () => import('@/modules/campanhas/campanhas-email/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'E-mail',
              pathName: null,
            },
          ],
          title: 'E-mail',
          requiredUserPermissions: ['campanhas/email-v2'],
          requiredModules: ['email_v2'],
        },
      },
      {
        path: 'email/resultados/:id',
        component: () => import('@/modules/campanhas/campanhas-email/views/pages/Results.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'E-mail',
              pathName: '/v3/campanhas/email',
            },
            {
              name: 'Campanha',
              pathName: null,
            },
          ],
          title: 'E-mail',
          requiredUserPermissions: ['campanhas/email-v2'],
          requiredModules: ['email_v2'],
        },
      },
      {
        path: 'centro-custo',
        alias: ['centro-custo', 'campanhas-centro-custo'],
        component: () => import('@/modules/campanhas/centro-custo/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Centros de custo',
              pathName: null,
            },
          ],
          title: 'Centros de custo',
          requiredUserPermissions: ['campanhas/centro_custo/visualizar'],
          requiredModules: ['campaigns_cost_center'],
        },
      },
      {
        path: 'pesquisa-satisfacao',
        name: 'list-surveys',
        component: () => import('@/modules/campanhas/pesquisa-satisfacao/views/pages/Index.vue'),
        meta: {
          title: 'Pesquisa de satisfação',
          requiredUserPermissions: SURVEY_ROUTE_PERMISSIONS_VIEW_ANY,
          requiredUserPermissionsMatch: 'any',
          requiredModules: ['survey'],
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Pesquisa de satisfação',
              pathName: null,
            },
          ],
        },
      },
      {
        path: 'pesquisa-satisfacao/nova',
        name: 'new-survey',
        component: () => import('@/modules/campanhas/pesquisa-satisfacao/views/pages/EditSurvey.vue'),
        meta: {
          title: 'Nova pesquisa',
          requiredUserPermissions: SURVEY_ROUTE_PERMISSIONS_MANAGE_ANY,
          requiredUserPermissionsMatch: 'any',
          requiredModules: ['survey'],
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Pesquisa de satisfação',
              pathName: '/v3/campanhas/pesquisa-satisfacao',
            },
            {
              name: 'Nova pesquisa',
              pathName: null,
            },
          ],
        },
      },
      {
        path: 'pesquisa-satisfacao/editar/:id',
        name: 'edit-survey',
        component: () => import('@/modules/campanhas/pesquisa-satisfacao/views/pages/EditSurvey.vue'),
        meta: {
          title: 'Editar pesquisa',
          requiredUserPermissions: SURVEY_ROUTE_PERMISSIONS_MANAGE_ANY,
          requiredUserPermissionsMatch: 'any',
          requiredModules: ['survey'],
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Pesquisa de satisfação',
              pathName: '/v3/campanhas/pesquisa-satisfacao',
            },
            {
              name: 'Editar pesquisa',
              pathName: null,
            },
          ],
        },
      },
      {
        path: 'pesquisa-satisfacao/resultados/:id',
        name: 'results-survey',
        component: () => import('@/modules/campanhas/pesquisa-satisfacao/views/pages/SurveyResults.vue'),
        meta: {
          title: 'Resultados da pesquisa',
          requiredUserPermissions: SURVEY_ROUTE_PERMISSIONS_VIEW_ANY,
          requiredUserPermissionsMatch: 'any',
          requiredModules: ['survey'],
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Pesquisa de satisfação',
              pathName: '/v3/campanhas/pesquisa-satisfacao',
            },
            {
              name: 'Resultados da pesquisa',
              pathName: null,
            },
          ],
        },
      },
    ],
  },
]
